import script from "./auction-layout.vue?vue&type=script&setup=true&lang=js"
export * from "./auction-layout.vue?vue&type=script&setup=true&lang=js"

import "./auction-layout.vue?vue&type=style&index=0&id=319794dd&lang=css"

const __exports__ = script;

export default __exports__